import { Field } from '@progress/kendo-react-form';
import React from 'react'; 
import comdetailsdata from '../data/comdetailsdata.json';
import { CusFormLabel } from '../validation/Form-Components';
import config from '../appconfig/config.json';

const BizRegisterAddress = (props) => { 
    const {addType, response} = props

    return(
        <div>
            {addType === config.addTypeForeign?
            <div>
                <Field component={CusFormLabel} 
                    leftLabelId={'lblAddline1'} leftLabelName={comdetailsdata.label.AddLine1}
                    id={'addline1'} name={response.Address_Line_1 !==null? response.Address_Line_1:''}/>

                <Field component={CusFormLabel} 
                    leftLabelId={'lblAddline1'} leftLabelName={comdetailsdata.label.AddLine2}
                    id={'addline1'} name={response.Address_Line_2 !==null? response.Address_Line_2:''}/>  
            </div>:
            <div>
                <Field component={CusFormLabel} 
                    leftLabelId={'lblBlk'} leftLabelName={comdetailsdata.label.BlkNo} 
                    id={'blk'} name={response.Reg_Add_Block_No !== null? response.Reg_Add_Block_No:''} />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblStreet'} leftLabelName={comdetailsdata.label.Street}
                    id={'st'} name={response.Reg_Add_Street_Name !==null? response.Reg_Add_Street_Name:''} />
                             
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblLvl'} leftLabelName={comdetailsdata.label.FlrNum} 
                    id={'lvl'} name={response.Reg_Add_Floor_No !==null? response.Reg_Add_Floor_No:''}  />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblUno'} leftLabelName={comdetailsdata.label.UnitNo}
                    id={'uno'} name={response.Reg_Add_Unit_No !==null? response.Reg_Add_Unit_No:''}  />
                               
                  <Field component={CusFormLabel} 
                    leftLabelId={'lblbuilding'} leftLabelName={comdetailsdata.label.BldName} 
                    id={'bld'} name={response.Reg_Add_Bldg_Name !==null? response.Reg_Add_Bldg_Name:''}  />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblPostalCode'} leftLabelName={comdetailsdata.label.PostalCode}
                    id={'ptc'} name={response.Reg_Add_Postal_Code !==null? response.Reg_Add_Postal_Code:''} />

                  <Field component={CusFormLabel} 
                    leftLabelId={'lblcountry'} leftLabelName={comdetailsdata.label.Country}
                    id={'ctry'} name={'SINGAPORE'}/>
            </div>}
        </div>
    )
}

export default BizRegisterAddress